import api from "./index";

export const getGuestsService = async (params) =>
  await api.get(
    `/exhibitor/events/digital-invites-integration/${params.eventId}`
  );

export const SignOnSystemGuestsService = async (params) =>
  await api.post("/digital-invites/auth", params);
